import { ROUTE_LOGIN, ROUTE_FORGOT_PASSWORD } from "../constants";
import './Auth.css'

const ForgotPasswordThankYou = () => {

  return (
    <div className="auth-screen">
      <h2 className="title">Thank you</h2>
      <div className='instruction'>Please check your email to reset your password.</div>
      <div className="signup-link">
        Did not receive email? <a href={ROUTE_FORGOT_PASSWORD}>Try again</a>
      </div>
      <div className="signup-link">
        Or go back to <a href={ROUTE_LOGIN}>Login</a>
      </div>
    </div>
  );
};

export default ForgotPasswordThankYou;
